export const SET_LOADING = '@auth/SET_LOADING';

export const LOGOUT_REQUEST = '@auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = '@auth/LOGOUT_SUCCESS';

export const REFRESH_REQUEST = '@auth/REFRESH_REQUEST';

export const RESET_PASSWORD_REQUEST = '@auth/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = '@auth/RESET_PASSWORD_SUCCESS';

export const LOGIN_REQUEST = '@auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = '@auth/LOGIN_SUCCESS';

export const SET_USER_SELECTED_FOR_CONTEXT = '@auth/SET_USER_SELECTED_FOR_CONTEXT';

export const CLEAR_STATE = '@auth/CLEAR_STATE';

export const OPEN_CHANGE_PASSWORD_MODAL = '@auth/OPEN_CHANGE_PASSWORD_MODAL';
export const CHANGE_PASSWORD_SUCCESS = '@auth/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_CANCEL = '@auth/CHANGE_PASSWORD_CANCEL';
export const CHANGE_PASSWORD_REQUEST = '@auth/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_LOADING = '@auth/CHANGE_PASSWORD_LOADING';
